import { StyleSheet } from 'react-native';

export const sharedStyle = StyleSheet.create({
  footerText: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 18,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  progress: {
    flex: 1,
    minHeight: 21,
    flexDirection: 'row',
  },
  wrapperLeft: {
    paddingHorizontal: 8,
    flexDirection: 'row',
    gap: 8,
  },
  wrapperRight: {
    paddingHorizontal: 8,
    flexDirection: 'row',
    gap: 8,
  },
  tableDiscount: {
    justifyContent: 'flex-start',
    flex: 2.5,
    width: '100%',
  },
  progressBarWrapper: {
    flex: 1,
    minWidth: 326,
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  progress: {
    flex: 1,
    minWidth: 326,
    minHeight: 21,
    width: '100%',
    paddingHorizontal: 24,
    flexDirection: 'row',
    marginTop: 12,
  },
  wrapperLeft: {
    flex: 1,
    flexDirection: 'row',
    paddingRight: 8,
  },
  wrapperRight: {
    flex: 1,
    paddingLeft: 8,
  },
  tableDiscount: {
    width: '100%',
  },
  progressBarWrapper: {
    flex: 1,
    minWidth: 50,
  },
});
